import React, { useMemo, useState } from "react";
import EAButton from "../Buttons/EAButton";
import EADivider from "../EADivider";
import "./EAProductCard.scss";
import EASkeletonLoader from "../EASkeletonLoader";
import { useTranslation } from "react-i18next";
import { MdImageNotSupported } from "react-icons/md";
import EAModal from "../Modal/EAModal";
import { stripHtml } from "../../../../utils/stripHtml";

interface IProps {
  title: string;
  pictureUrl: string;
  description: string;
  mainPrice: number;
  additionalPriceInfo?: string;
  onClick?: () => void;
  buttonTitle: string;
  buttonStartIcon?: React.ReactNode;
  loading?: boolean;
  listPrice: number;
}

const EAProductCard: React.FC<IProps> = ({
  title,
  pictureUrl,
  description,
  mainPrice,
  additionalPriceInfo = "",
  onClick = () => {},
  buttonTitle,
  buttonStartIcon = <></>,
  loading = false,
  listPrice,
}) => {
  const { t } = useTranslation();
  const [readMore, setReadMore] = useState(false);
  const isDiscount = mainPrice !== listPrice;
  const descriptionPreview = useMemo(() => stripHtml(description), [description]);

  if (loading) {
    return <EASkeletonLoader height="500px" />;
  }

  return (
    <>
      <div className="product-card-container">
        {pictureUrl ? (
          <img className="product-card__image" alt="Miniatura zdjęcia produktu" src={pictureUrl} />
        ) : (
          <div className="product-card__empty-image">
            <MdImageNotSupported />
          </div>
        )}

        <div className="product-card__content">
          <h4 className="product-card__content-title">{title}</h4>
          <p className="product-card__content-description">{descriptionPreview}</p>
          <EAButton variant="text" title={t("Czytaj więcej")} noMargins onClick={() => setReadMore(true)} />
        </div>
        <EADivider />

        <div className="product-card__summary">
          <div className="product-card__price">
            <div className="price-container">
              <h5 className={`price ${isDiscount ? "price-through" : ""}`}>
                {listPrice.toFixed(2)} {t("zl")}
              </h5>
              {isDiscount && (
                <h5 className={`price ${isDiscount ? "price-through-color" : ""}`}>
                  {mainPrice.toFixed(2)} {t("zl")}
                </h5>
              )}
            </div>

            <span className="caption">{additionalPriceInfo}</span>
          </div>

          <EAButton title={buttonTitle} startIcon={buttonStartIcon} onClick={onClick} />
        </div>
      </div>

      <EAModal
        isOpen={readMore}
        title={title}
        onClose={() => setReadMore(false)}
        cancelButtonLabel={t("przeczytalem")}
        hideAcceptButton
      >
        <p dangerouslySetInnerHTML={{ __html: description }}></p>
      </EAModal>
    </>
  );
};

export default EAProductCard;
